<template>
    <div class="chat-user-interaction-item">
        <div
            class="chat-user-interaction-item__url"
        >
            <svg-icon
                :icon="BellIcon"
                is-custom-icon
                color="lavender-blue-500"
                :size="IconSize.xs"
            />
            <bar-skeleton :width="140" />
        </div>
        <div class="chat-user-interaction-item__content">
            <flex-container :gap="Size.sm">
                <bar-skeleton
                    v-for="(width, index) in skeletonWidths"
                    :key="index"
                    :width="width"
                    :height="18"
                />
            </flex-container>
        </div>
        <div class="chat-user-interaction-item__footer">
            <bar-skeleton :width="60" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import BellIcon from '@keyvue/one-awesome-icons/icons/solid/bell.svg';
    import { IconSize, Size } from '@keyvue/one-ui';

    const count = getRandomInt(1, 5);

    const skeletonWidths = Array.from({ length: count }, (_, i) => {
        if (i === count - 1) {
            return getRandomInt(100, 450);
        }
        return 450;
    });

    function getRandomInt(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
</script>

<style scoped lang="scss">
    .chat-user-interaction-item {
        max-width: 80%;
        align-self: flex-start;
        font-size: font-size(xs);

        &__url {
            padding: size(sm) size(sm) size(sm) 0px;
            display: flex;
            gap: size(xs);
            align-items: center;
        }

        &__content {
            padding: size(md);
            border-radius: size(sm);
            background-color: var(--theme-colors-default--white);
            color: var(--theme-colors-default--gray-800);
            border-bottom: 1px solid var(--theme-colors-default--gray-300);
            box-shadow: 0 0 5px 0 rgba(0,0,0,0.15);
            line-height: 19px;
        }

        &__footer {
            padding-top: 5px;
        }
    }
</style>
